module.exports = __webpack_public_path__ + "ff846a8bcbbc392fba4834cced8346d9.svg";